import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "container-fix-padding" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "d-flex flex-column" }
const _hoisted_4 = { class: "inquiry-header" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "d-flex justify-end" }
const _hoisted_7 = { class: "text-grey text-caption" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "comment-body" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 0,
  class: "comment-actions"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "d-flex mt-2" }
const _hoisted_15 = {
  key: 0,
  class: "add-comment-section"
}
const _hoisted_16 = {
  key: 1,
  class: "new-comment-form"
}
const _hoisted_17 = { class: "d-flex mt-2" }

import { ref, computed, watch, onMounted, onUpdated, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import api from '../../../api/v2/api'
import Comment from '../../../api/v2/models/comment'
import CommentForm from '../../../api/v2/forms/comment'
import ConfirmDialog from '../atoms_molecules/ConfirmDialog.vue'
import ButtonBack from '../atoms_molecules/ButtonBack.vue'
import Simplemde from '../atoms_molecules/Simplemde.vue'
import { userState } from '../../stores/user'
import { headerState } from '../../stores/header'
import Inquiry from '../../../api/v2/models/inquiry'
import InquiryView from '../atoms_molecules/InquiryView.vue'
import UserInquiryDialog from '../organisms/UserInquiryDialog.vue'
import { ROUTER_NAME } from '../../router'

// Router

export default /*@__PURE__*/_defineComponent({
  __name: 'InquiryDetail',
  setup(__props) {

const route = useRoute()
const router = useRouter()

// Template refs
const confirm = ref<InstanceType<typeof ConfirmDialog> | null>(null)

// Reactive state
const inquiry = ref<Inquiry | null>(null)
const newComment = ref('')
const breadcrumbs = ref([
  {
    text: 'クラスルーム',
    disabled: false,
    exact: true,
    to: '/classroom/'
  },
  {
    text: '問い合わせ一覧',
    disabled: false,
    exact: true,
    to: '/classroom/inquiries'
  }
])

// Computed properties
const user = computed(() => {
  return userState.user
})

const breadcrumbItems = computed(() => {
  return breadcrumbs.value.map(b => ({
    text: b.text,
    to: b.disabled ? undefined : b.to
  }))
})

// Methods
const getInquiry = async () => {
  try {
    inquiry.value = await api.inquiry.show(route.params.inquiryId as string)
    if (inquiry.value) {
      headerState.setTitle(inquiry.value.title)

      breadcrumbs.value.push({
        text: inquiry.value.title,
        disabled: true,
        exact: false,
        to: ''
      })
    }
  } catch (e) {
    console.error('Failed to load inquiry:', e)
  }
}

const createComment = async () => {
  try {
    const commentForm = new CommentForm()
    commentForm.body = newComment.value
    commentForm.commentableId = parseInt(route.params.inquiryId as string)
    commentForm.commentableType = 'Inquiry'
    await api.comment.create(commentForm)

    newComment.value = ''
    inquiry.value = await api.inquiry.show(route.params.inquiryId as string)
    if (inquiry.value) {
      inquiry.value.showCommentForm = false
    }
  } catch (e) {
    // Handle error silently
  }
}

const updateComment = async (comment: Comment) => {
  try {
    await api.comment.update(comment.id, { body: comment.body })
    comment.isEditing = false
    inquiry.value = await api.inquiry.show(route.params.inquiryId as string)
  } catch (e) {
    // Handle error silently
  }
}

const deleteComment = async (commentId: number) => {
  try {
    if (confirm.value && await (confirm.value as any).open('本当によろしいですか？')) {
      await api.comment.delete(commentId)
      inquiry.value = await api.inquiry.show(route.params.inquiryId as string)
    }
  } catch (e) {
    // Handle error silently
  }
}

const deleteInquiry = async (id: number) => {
  try {
    if (confirm.value && await (confirm.value as any).open('本当によろしいですか？')) {
      await api.inquiry.delete(id)

      router.push({
        name: ROUTER_NAME.INQUIRY_LIST,
      })
    }
  } catch (e) {
    // Handle error silently
  }
}

// Watchers
watch(() => route.params.inquiryId, async (newVal, oldVal) => {
  if (newVal && newVal !== oldVal) {
    try {
      inquiry.value = await api.inquiry.show(route.params.inquiryId as string)
      if (inquiry.value) {
        headerState.setTitle(inquiry.value.title)
      }
    } catch (e) {
      console.error('Failed to load inquiry on route change:', e)
    }
  }
})

// Lifecycle
onMounted(() => {
  getInquiry()
})

onUpdated(() => {
  nextTick(() => {
    if (route.hash) {
      const el = document.querySelector(route.hash)
      el && el.scrollIntoView()
    }
  })
})

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (inquiry.value && breadcrumbItems.value && breadcrumbItems.value.length)
      ? (_openBlock(), _createBlock(_component_AppBreadcrumb, {
          key: 0,
          items: breadcrumbItems.value
        }, null, 8 /* PROPS */, ["items"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_col, {
        lg: "12",
        class: "bg-white pa-0"
      }, {
        default: _withCtx(() => [
          (inquiry.value)
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 0,
                variant: "flat",
                tile: "",
                class: "inquiry-detail-card"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      (!inquiry.value.isEditing)
                        ? (_openBlock(), _createBlock(InquiryView, {
                            key: 0,
                            inquiry: inquiry.value
                          }, {
                            action: _withCtx(() => [
                              _createVNode(UserInquiryDialog, {
                                inquiry: inquiry.value,
                                onInquirySubmited: getInquiry
                              }, null, 8 /* PROPS */, ["inquiry"]),
                              _createVNode(_component_v_btn, {
                                size: "small",
                                color: "red",
                                variant: "tonal",
                                class: "ms-2",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(() => { deleteInquiry(inquiry.value.id) }, ["stop"]))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { size: "small" }, {
                                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                      _createTextVNode("mdi-delete", -1 /* CACHED */)
                                    ]))]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["inquiry"]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createVNode(_component_v_divider),
                    _createVNode(_component_v_card_text, { class: "inquiry-content" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "mb-4 html-body",
                          innerHTML: inquiry.value.content
                        }, null, 8 /* PROPS */, _hoisted_5),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("span", _hoisted_7, _toDisplayString(inquiry.value.updatedAt.substring(0, 10)) + "に問い合わせしました", 1 /* TEXT */)
                        ]),
                        _createVNode(_component_v_divider, { class: "my-4" }),
                        _createCommentVNode(" Comments Section "),
                        _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "comments-title" }, "コメント", -1 /* CACHED */)),
                        _createVNode(_component_v_list, {
                          density: "compact",
                          class: "comments-list"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inquiry.value.comments, (comment) => {
                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                key: comment.id,
                                id: `comment-${comment.id}`,
                                class: "comment-item"
                              }, _createSlots({
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_9, [
                                    (!comment.isEditing)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createElementVNode("div", {
                                            class: "html-body",
                                            innerHTML: comment.renderedBody
                                          }, null, 8 /* PROPS */, _hoisted_10),
                                          (comment.user && comment.user.id == user.value.id)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                _createElementVNode("a", {
                                                  class: "me-3",
                                                  onClick: ($event: any) => (comment.isEditing = true)
                                                }, "編集", 8 /* PROPS */, _hoisted_12),
                                                _createElementVNode("a", {
                                                  class: "text-red",
                                                  onClick: ($event: any) => (deleteComment(comment.id))
                                                }, "消去", 8 /* PROPS */, _hoisted_13)
                                              ]))
                                            : _createCommentVNode("v-if", true)
                                        ], 64 /* STABLE_FRAGMENT */))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createVNode(Simplemde, {
                                            modelValue: comment.body,
                                            "onUpdate:modelValue": ($event: any) => ((comment.body) = $event),
                                            rows: 3,
                                            name: "comment-body-new"
                                          }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]),
                                          _createElementVNode("div", _hoisted_14, [
                                            _createVNode(_component_v_btn, {
                                              color: "primary",
                                              size: "small",
                                              class: "me-2",
                                              onClick: ($event: any) => (updateComment(comment))
                                            }, {
                                              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                                _createTextVNode("コメントを送信する", -1 /* CACHED */)
                                              ]))]),
                                              _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["onClick"]),
                                            _createVNode(_component_v_btn, {
                                              size: "small",
                                              variant: "outlined",
                                              onClick: ($event: any) => (comment.isEditing = false)
                                            }, {
                                              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                                _createTextVNode("キャンセル", -1 /* CACHED */)
                                              ]))]),
                                              _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["onClick"])
                                          ])
                                        ], 64 /* STABLE_FRAGMENT */))
                                  ])
                                ]),
                                _: 2 /* DYNAMIC */
                              }, [
                                (comment.user && comment.user.image)
                                  ? {
                                      name: "prepend",
                                      fn: _withCtx(() => [
                                        _createVNode(_component_v_avatar, { size: "36" }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("img", {
                                              src: comment.user.image.url
                                            }, null, 8 /* PROPS */, _hoisted_8)
                                          ]),
                                          _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */)
                                      ]),
                                      key: "0"
                                    }
                                  : undefined
                              ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["id"]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createCommentVNode(" Add Comment Section "),
                        (!inquiry.value.showCommentForm)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createVNode(_component_v_icon, {
                                color: "primary",
                                size: "small",
                                class: "me-1"
                              }, {
                                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                  _createTextVNode("mdi-comment-plus", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              }),
                              _createElementVNode("a", {
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (inquiry.value.showCommentForm = true))
                              }, "コメントを追加…")
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createVNode(Simplemde, {
                                modelValue: newComment.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newComment).value = $event)),
                                rows: 3,
                                name: "comment-new"
                              }, null, 8 /* PROPS */, ["modelValue"]),
                              _createElementVNode("div", _hoisted_17, [
                                _createVNode(_component_v_btn, {
                                  color: "primary",
                                  size: "small",
                                  class: "me-2",
                                  onClick: createComment
                                }, {
                                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                    _createTextVNode("コメントを送信する", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_btn, {
                                  size: "small",
                                  variant: "outlined",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (inquiry.value.showCommentForm = false))
                                }, {
                                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                    _createTextVNode("キャンセル", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                })
                              ])
                            ]))
                      ]),
                      _: 1 /* STABLE */
                    })
                  ])
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createVNode(ConfirmDialog, {
      ref_key: "confirm",
      ref: confirm
    }, null, 512 /* NEED_PATCH */)
  ]))
}
}

})